import React, { FC } from 'react';
import './Loader.scss';

const Loader: FC<any> = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader is-loading" />
    </div>
  );
};

export default Loader;
